import { z } from 'zod';

// ---------- Audit log (step 1 §94–95) ----------
export const auditEntrySchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  actorId: z.string().nullable(),
  actorName: z.string().nullable(),
  action: z.string(),
  entityType: z.string(),
  entityId: z.string(),
  before: z.unknown().nullable(),
  after: z.unknown().nullable(),
  metadata: z.unknown().nullable(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  requestId: z.string().nullable(),
});
export type AuditEntryView = z.infer<typeof auditEntrySchema>;

export const auditQuerySchema = z.object({
  actorId: z.string().max(60).optional(),
  action: z.string().max(80).optional(),
  entityType: z.string().max(60).optional(),
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
  cursor: z.string().max(80).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type AuditQuery = z.infer<typeof auditQuerySchema>;
export const auditPageSchema = z.object({ items: z.array(auditEntrySchema), nextCursor: z.string().nullable() });
export type AuditPage = z.infer<typeof auditPageSchema>;

// ---------- Feature flags (step 1 §112) ----------
export const featureFlagKeys = ['linkedinAds', 'abTesting', 'outreachAutomation', 'newAnalytics'] as const;
export const featureFlagSchema = z.object({
  key: z.string(),
  description: z.string(),
  enabled: z.boolean(),
  /** Staged rollout: percentage of subjects (users) that see the feature when enabled. */
  rolloutPercent: z.number().int().min(0).max(100),
  updatedAt: z.string(),
});
export type FeatureFlagView = z.infer<typeof featureFlagSchema>;
export const featureFlagUpdateSchema = z.object({ enabled: z.boolean().optional(), rolloutPercent: z.number().int().min(0).max(100).optional() });
export type FeatureFlagUpdate = z.infer<typeof featureFlagUpdateSchema>;

// ---------- Dev mail capture ----------
export const emailMessageViewSchema = z.object({ id: z.string(), kind: z.string(), toEmail: z.string(), subject: z.string(), bodyText: z.string(), createdAt: z.string() });
export type EmailMessageView = z.infer<typeof emailMessageViewSchema>;
